import React from "react";

import FactorySection from "../components/FactorySection";
import ProductSlider from "../components/ProductSlider";
import WhyChooseUs from "../components/WhyChooseUs";
import CommonBanner from "../components/CommonBanner";

const Home = () => {
  return (
    <div className="page-container">
      <CommonBanner />
      <FactorySection />
      <ProductSlider />
      <WhyChooseUs />
    </div>
  );
};

export default Home;
